import { Protected } from "@stardeck-customer-apps/project-auth";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import AdminDashboard from "@/pages/admin/admin-dashboard";
import AdminNews from "@/pages/admin/news";
import AdminNewsCategories from "@/pages/admin/news-categories";
import AdminNewsEdit from "@/pages/admin/news-edit";
import AdminNewsNew from "@/pages/admin/news-new";
import AdminNewsletter from "@/pages/admin/newsletter";
import AdminSettings from "@/pages/admin/settings";
import { LuckyLayout } from "@/pages/layout";
import LoginPage from "@/pages/login";
import { About } from "@/pages/lucky/about";
import { Compatibility } from "@/pages/lucky/compatibility";
import { CompatibilityResult } from "@/pages/lucky/compatibility-result";
import { Contact } from "@/pages/lucky/contact";
import { Daily } from "@/pages/lucky/daily";
import { Home } from "@/pages/lucky/home";
import { NewsList } from "@/pages/lucky/news";
import { NewsDetail } from "@/pages/lucky/news-detail";
import { NotFound } from "@/pages/not-found";
import { Unauthorized } from "@/pages/unauthorized";
import { Providers } from "@/providers";

function AppRoutes() {
  return (
    <Router>
      <Providers>
        <div className="dark min-h-dvh">
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route element={<LuckyLayout />}>
              <Route path="/unauthorized" element={<Unauthorized />} />
              <Route path="/" element={<Home />} />
              <Route path="/daily" element={<Daily />} />
              <Route path="/compatibility" element={<Compatibility />} />
              <Route path="/compatibility/result" element={<CompatibilityResult />} />
              <Route path="/news" element={<NewsList />} />
              <Route path="/news/:slug" element={<NewsDetail />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route
                path="/admin"
                element={
                  <Protected
                    requiredPermission="deployment:admin-panel:write"
                    redirectTo="/login"
                    redirectOnUnauthorizedTo="/unauthorized"
                  >
                    <AdminDashboard />
                  </Protected>
                }
              />
              <Route
                path="/admin/news"
                element={
                  <Protected
                    requiredPermission="deployment:admin-panel:write"
                    redirectTo="/login"
                    redirectOnUnauthorizedTo="/unauthorized"
                  >
                    <AdminNews />
                  </Protected>
                }
              />
              {/* News admin routes */}
              <Route
                path="/admin/news/new"
                element={
                  <Protected
                    requiredPermission="deployment:admin-panel:write"
                    redirectTo="/login"
                    redirectOnUnauthorizedTo="/unauthorized"
                  >
                    <AdminNewsNew />
                  </Protected>
                }
              />
              <Route
                path="/admin/news/:slug/edit"
                element={
                  <Protected
                    requiredPermission="deployment:admin-panel:write"
                    redirectTo="/login"
                    redirectOnUnauthorizedTo="/unauthorized"
                  >
                    <AdminNewsEdit />
                  </Protected>
                }
              />

              <Route
                path="/admin/newsletter"
                element={
                  <Protected
                    requiredPermission="deployment:admin-panel:write"
                    redirectTo="/login"
                    redirectOnUnauthorizedTo="/unauthorized"
                  >
                    <AdminNewsletter />
                  </Protected>
                }
              />
              <Route
                path="/admin/news-categories"
                element={
                  <Protected
                    requiredPermission="deployment:admin-panel:write"
                    redirectTo="/login"
                    redirectOnUnauthorizedTo="/unauthorized"
                  >
                    <AdminNewsCategories />
                  </Protected>
                }
              />
              <Route
                path="/admin/settings"
                element={
                  <Protected
                    requiredPermission="deployment:admin-panel:write"
                    redirectTo="/login"
                    redirectOnUnauthorizedTo="/unauthorized"
                  >
                    <AdminSettings />
                  </Protected>
                }
              />
            </Route>
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </Providers>
    </Router>
  );
}

export default AppRoutes;
